(function () {
	"use strict";

	$(document).ready(function () {

		//Making modal buttons keyboard focusable
		$(".btn-modal-contactForm").each(function (i, val) {
			$(this).attr("tabindex", 0);
		});

		$(".close").each(function (i, val) {
			$(this).attr("tabindex", 0);
		});
	});
	//Form management
	var $btnContactFrom = $(".btn-modal-contactForm");

	// Open contact form modal
	$btnContactFrom.on("click", function () {
		$("#carriers-contact-form").load(
			"carriers-contact-form",
			function () {
				initAvastForm();
				$("#carriers-contact-form").siblings().show();
				$("#carriers-contact-form")
					.find('input.button[type="submit"]')
					.removeClass("button blue large")
					.addClass("btn btn-primary btn-lg");
			}
		);
	});

	// Contact form after success
	$(document).on("avastform-linear-success", function () {
		initAvastForm();
		$("#carriers-contact-form").siblings().hide();
	});

	function finishForm() {
		initAvastForm();
		$("#carriers-contact-form").siblings().hide();
	}
})();
